var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Messages',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSignedIn && _vm.isValidCode),expression:"isSignedIn && isValidCode"}],attrs:{"code":_vm.code,"showAllUsers":""}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }